import { render, staticRenderFns } from "./LoginCollected.vue?vue&type=template&id=3159edd8&scoped=true&"
import script from "./LoginCollected.vue?vue&type=script&lang=js&"
export * from "./LoginCollected.vue?vue&type=script&lang=js&"
import style0 from "./LoginCollected.vue?vue&type=style&index=0&id=3159edd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3159edd8",
  null
  
)

export default component.exports